import React, { Suspense, lazy } from 'react';
import { Header } from './components/Header';
import { ProductHero } from './components/ProductHero';
import { ProductBenefits } from './components/ProductBenefits';
import { RecipesSample } from './components/RecipesSample';
import { Footer } from './components/Footer';
// Lazy load components below the fold
const VideoSection = lazy(() => import('./components/VideoSection').then(module => ({
  default: module.VideoSection
})));
const SpecialOffer = lazy(() => import('./components/SpecialOffer').then(module => ({
  default: module.SpecialOffer
})));
const ProductDescription = lazy(() => import('./components/ProductDescription').then(module => ({
  default: module.ProductDescription
})));
const HowToUse = lazy(() => import('./components/HowToUse').then(module => ({
  default: module.HowToUse
})));
const ResultsSection = lazy(() => import('./components/ResultsSection').then(module => ({
  default: module.ResultsSection
})));
const BundleShowcase = lazy(() => import('./components/BundleShowcase').then(module => ({
  default: module.BundleShowcase
})));
const HowItWorks = lazy(() => import('./components/HowItWorks').then(module => ({
  default: module.HowItWorks
})));
const TreatmentTypes = lazy(() => import('./components/TreatmentTypes').then(module => ({
  default: module.TreatmentTypes
})));
const FAQ = lazy(() => import('./components/FAQ').then(module => ({
  default: module.FAQ
})));
const Reviews = lazy(() => import('./components/Reviews').then(module => ({
  default: module.Reviews
})));
const RelatedProducts = lazy(() => import('./components/RelatedProducts').then(module => ({
  default: module.RelatedProducts
})));
// Simple loading fallback component
const LoadingFallback = () => <div className="py-8" data-id="element-0" />;
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-1">
      <Header data-id="element-2" />
      <main data-id="element-3">
        <ProductHero data-id="element-4" />
        <ProductBenefits data-id="element-5" />
        <RecipesSample data-id="element-6" />
        {/* Split into multiple Suspense boundaries to reduce load */}
        <Suspense fallback={<LoadingFallback data-id="element-8" />} data-id="element-7">
          <VideoSection data-id="element-9" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-11" />} data-id="element-10">
          <SpecialOffer data-id="element-12" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-14" />} data-id="element-13">
          <ProductDescription data-id="element-15" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-17" />} data-id="element-16">
          <HowToUse data-id="element-18" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-20" />} data-id="element-19">
          <ResultsSection data-id="element-21" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-23" />} data-id="element-22">
          <BundleShowcase data-id="element-24" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-26" />} data-id="element-25">
          <HowItWorks data-id="element-27" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-29" />} data-id="element-28">
          <TreatmentTypes data-id="element-30" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-32" />} data-id="element-31">
          <FAQ data-id="element-33" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-35" />} data-id="element-34">
          <Reviews data-id="element-36" />
        </Suspense>
        <Suspense fallback={<LoadingFallback data-id="element-38" />} data-id="element-37">
          <RelatedProducts data-id="element-39" />
        </Suspense>
      </main>
      <Footer data-id="element-40" />
    </div>;
}